var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgStopwatch = function SvgStopwatch(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#03D47C",
    fillRule: "evenodd",
    d: "M8 1a1 1 0 0 0 0 2h1v1.07A7.002 7.002 0 0 0 10 18a7 7 0 0 0 5.606-11.192l.758-.758a1 1 0 1 0-1.414-1.414l-.758.758A6.965 6.965 0 0 0 11 4.07V3h1a1 1 0 1 0 0-2H8Zm2 5.5a1 1 0 0 1 1 1v3.586l1.707 1.707a1 1 0 1 1-1.414 1.414l-2-2A.997.997 0 0 1 9 11.47V7.5a1 1 0 0 1 1-1Z",
    clipRule: "evenodd"
  })));
};
export default SvgStopwatch;